import type { IColumn } from 'shared/ui/TableNew'
import type { RowMessagesComparison } from 'entities/Analytics/model/Table/RowMessagesComparison'
import { type SearchTypesEnum } from 'widgets/SearchDropdown'
import { getBreakdownColumnName } from 'pages/analytics/lib'
import { AnalyticMetricCell, BreakdownEntityCell } from 'pages/analytics/ui'

export const getColumns = (
  filterType: SearchTypesEnum | null
): IColumn<RowMessagesComparison>[] => [
  {
    field: 'name',
    name: getBreakdownColumnName(filterType),
    fullName: getBreakdownColumnName(filterType),
    isDisabledChangeVisible: true,
    renderRowCell: (row) => {
      const { name, breakdownEntity } = row.fields

      return (
        <BreakdownEntityCell
          filterType={filterType}
          breakdownEntity={breakdownEntity}
          fallbackName={name}
        />
      )
    },
  },
  {
    field: 'total_inbound',
    name: 'Total Inbound',
    renderRowCell: (row) => {
      const { total_inbound } = row.fields

      return <AnalyticMetricCell value={total_inbound} />
    },
  },
  {
    field: 'total_outbound',
    name: 'Total Outbound',
    renderRowCell: (row) => {
      const { total_outbound } = row.fields

      return <AnalyticMetricCell value={total_outbound} />
    },
  },
  {
    field: 'delivered',
    name: 'Delivery Rate',
    renderRowCell: (row) => {
      const { delivered, total_outbound } = row.fields
      const percentage = total_outbound > 0 ? Math.round((delivered / total_outbound) * 100) : 0

      return <>{percentage}%</>
    },
  },
  {
    field: 'undelivered',
    name: 'Error Rate',
    renderRowCell: (row) => {
      const { undelivered, total_outbound } = row.fields
      const percentage = total_outbound > 0 ? Math.round((undelivered / total_outbound) * 100) : 0

      return <>{percentage}%</>
    },
  },
  {
    field: 'carrier_violations',
    name: 'Spam Rate',
    renderRowCell: (row) => {
      const { carrier_violations, total_outbound } = row.fields
      const percentage =
        total_outbound > 0 ? Math.round((carrier_violations / total_outbound) * 100) : 0

      return <>{percentage}%</>
    },
  },
  {
    field: 'total_rvm',
    name: 'Total RVM',
    renderRowCell: (row) => {
      const { total_rvm } = row.fields

      return <AnalyticMetricCell value={total_rvm} />
    },
  },
  {
    field: 'delivered_rvm',
    name: 'Delivered RVM',
    renderRowCell: (row) => {
      const { delivered_rvm } = row.fields

      return <AnalyticMetricCell value={delivered_rvm} />
    },
  },
  {
    field: 'undelivered_rvm',
    name: 'Undelivered RVM',
    renderRowCell: (row) => {
      const { undelivered_rvm } = row.fields

      return <AnalyticMetricCell value={undelivered_rvm} />
    },
  },
]
